export default "__VITE_ASSET__BIi2X7Kz__"